import api from '../api';
import { SEND_UPDATED_NOTIFICATION } from '../constants/actionTypes';


export const updatedNotificationLink = (uid) => {
    return api.fetch(SEND_UPDATED_NOTIFICATION, api.config.updatedNotificationLink(uid), api.http.get())   
};
